export async function updateComment(prescriptionId, payload) {
  const res = await window.axios({
    method: 'PATCH',
    baseURL: process.env.VUE_APP_EPRES_ENDPOINT,
    url: `admin/prescription/${prescriptionId}/comment`,
    data: payload,
  });

  return res;
}
